module.exports = __webpack_public_path__ + "img/image.6c7cdafc.png";